import { toast } from "react-toastify";
import { useContext, useEffect, useState } from "react";
import { Search } from "@mui/icons-material";
import { CompanyContext } from "../../../../Contexts/CompanyContext";
import { createProjectWithGroupingAPI, getAllProjectsNotLinkedPaginatedByCompanyId } from "../../../../API/ProjectWithGroupingAPI";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { ProjectModel } from "../../../../Models/ProjectModel";
import { Modal, TableColumnsType, Button, Table, AutoComplete, Input, AutoCompleteProps } from "antd";
import { TableRowSelection } from "antd/es/table/interface";
import useLoading from "../../../../Hooks/useLoading";

interface IModalAddProjectToGroupingProps {
    showModal: boolean,
    groupingId: string,
    year: number,
    toggleShowModal: () => void,
    getAllProjectsPaginatedByGroupingId: (page: number) => Promise<void>
}

interface ISelectAddProjectHelper {
    page: number,
    rows: string[]
}

const ModalAddProjectToGrouping = (props: IModalAddProjectToGroupingProps) => {
    const { company } = useContext(CompanyContext);
    const [total, setTotal] = useState<number>(0);
    const [search, setSearch] = useState<string>();
    const [projects, setProjects] = useState<ProjectModel[]>([]);
    const { loading, toggleLoading } = useLoading();
    const [options, setOptions] = useState<AutoCompleteProps['options']>([]);
    const [selecteds, setSelecteds] = useState<ISelectAddProjectHelper[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [page, setPage] = useState<number>(1);
    const take = 5;

    const getAllProjectsNotLinked = async (page: number) => {
        try {
            toggleLoading(true);
            setPage(page);

            var text = search && search != "" ? search : "\"\"";

            await getAllProjectsNotLinkedPaginatedByCompanyId(company.id, props.groupingId, props.year, page, take, text).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setProjects(resp.data.items);
                    setTotal(resp.data.total);
                    setSelectedRowKeys(selecteds.find(x => x.page == page)?.rows ?? []);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const postProjectsToGrouping = async () => {
        try {
            toggleLoading(true);

            let allSelecteds = selecteds.map(x => x.rows.map(y => y)).flat();

            await createProjectWithGroupingAPI(allSelecteds.join(","), props.groupingId, company.id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Projetos atribuídos ao agrupamento com sucesso!");
                    props.getAllProjectsPaginatedByGroupingId(1);
                    setSelecteds([]);
                    setSelectedRowKeys([]);
                    props.toggleShowModal();
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const onSelectChange = (newSelectedRowKeys: React.Key[], selectedRow: ProjectModel[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
        let exist = selecteds.find(x => x.page == page);
        if (exist != undefined) {
            var newArray = selecteds;
            let removeInArray = exist?.rows.filter(x => !newSelectedRowKeys.includes(x));
            let addInArray = newSelectedRowKeys.filter(x => !exist?.rows.includes(x.toString())).map(x => x.toString());

            if (addInArray) {
                newArray.find(x => x.page == page)?.rows.push(...addInArray);

                setSelecteds(newArray);
            }
            
            if(removeInArray) {
                let rows = newArray.find(x => x.page == page)?.rows.filter(x => !removeInArray.includes(x));
                newArray = newArray.filter(x => x.page != page);
                newArray.push({
                    page: page,
                    rows: rows ?? []
                })

                setSelecteds(newArray);
            }
        }
        else {
            setSelecteds(prev => [...prev, { page: page, rows: selectedRow.map(x => x.id) }]);
        }
    };

    const onSelect = (value: string) => { };

    useEffect(() => {
        if (props.showModal) {
            getAllProjectsNotLinked(1);
        } else {
            setSearch("");
            setSelecteds([]);
            setSelectedRowKeys([]);
        }
    }, [props.showModal]);

    const columns: TableColumnsType<ProjectModel> = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
    ];

    const rowSelection: TableRowSelection<ProjectModel> = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <Modal
            title="Selecione os projetos para este Agrupamento"
            onCancel={props.toggleShowModal}
            open={props.showModal}
            width={800}
            footer={null}
            centered
            closable={true}
            className='modal-container'
        >
            <div className="mt-4">
                <AutoComplete
                    popupMatchSelectWidth={true}
                    options={options}
                    onSelect={onSelect}
                    className="w-100 pe-0"
                    onSearch={(val) => { setSearch(val) }}
                >
                    <Input.Search showCount={false} className="white" loading={loading} placeholder="Procurar" enterButton />
                </AutoComplete>
                <Table<ProjectModel>
                    loading={loading}
                    rowKey="id"
                    showHeader={false}
                    pagination={{
                        total: total,
                        pageSize: take,
                        onChange: (page, pageSize) => {
                            getAllProjectsNotLinked(page);
                        },
                    }}
                    className="mt-2"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={projects}
                />
            </div>
            <div className='btns-delete-modal'>
                <Button
                    type='default'
                    color="default"
                    onClick={props.toggleShowModal}
                    className='btn-modal-cancel'
                >
                    Cancelar
                </Button>
                <Button
                    type='primary'
                    color="primary"
                    className='btn-modal-confirm'
                    disabled={selecteds.filter(x => x.rows.length > 0).length == 0}
                    onClick={postProjectsToGrouping}
                >
                    Confirmar
                </Button>
            </div>
        </Modal>
    )
}

export default ModalAddProjectToGrouping;